var e = `Deze coupon code is niet geldig.`,
	t = `
	mutation CreateCheckoutCodeCart($input: CartInput!) {
		cartCreate(input: $input) {
			cart {
				checkoutUrl
				discountCodes {
					code
					applicable
				}
				appliedGiftCards {
					lastCharacters
				}
			}
			userErrors {
				field
				message
			}
		}
	}
`,
	n = ``,
	r = ``;
async function i({ eventSource: e, line: t, quantity: n, signal: r, ...i }) {
	if (!Number.isFinite(t) || !Number.isFinite(n))
		throw Error(`Cart line and quantity are required`);
	let a = await E(`${u()}cart/change.js`, {
		line: t,
		quantity: n,
		signal: r,
		fallbackMessage: `Unable to update cart`,
	});
	if (!a.ok) return a;
	let o = await s(i);
	return o.ok
		? (c(a.cart.item_count),
			l(a.cart, e),
			{ ok: !0, cart: a.cart, root: o.root })
		: o;
}
async function a({
	eventSource: e,
	properties: t,
	quantity: n,
	sellingPlanId: r,
	variantId: i,
	...a
}) {
	if (!i || !Number.isFinite(n) || n < 1)
		throw Error(`Cart line variant and quantity are required`);
	let o = { id: i, quantity: n };
	t && Object.keys(t).length && (o.properties = t), r && (o.selling_plan = r);
	let d = await E(`${u()}cart/add.js`, {
		items: [o],
		fallbackMessage: `Unable to restore cart line`,
	});
	if (!d.ok) return d;
	let f = await s(a);
	if (!f.ok) return f;
	let p = Number(f.root.getAttribute(`data-cart-item-count`)),
		m = { ...d.cart, ...(Number.isFinite(p) ? { item_count: p } : {}) };
	return (
		Number.isFinite(p) && c(p),
		l(m, e),
		{
			ok: !0,
			cart: m,
			root: f.root,
			restoredLineKey: String(d.cart.items?.[0]?.key || ``),
		}
	);
}
async function o({ code: e, couponSelector: t, eventSource: n, ...r }) {
	let i = g(e),
		a = await E(`${u()}cart/update.js`, {
			discount: e,
			fallbackMessage: T(r.currentRoot),
		});
	if (!a.ok) return a;
	let o = await s(r);
	if (!o.ok) return { ...o, cart: a.cart };
	let d = i === ``,
		f = d || w(a.cart, i) || D(o.root, t, i);
	return f
		? (c(a.cart.item_count),
			l(a.cart, n),
			{
				ok: !0,
				applied: f,
				appliedCode: d ? `` : String(e).trim(),
				discountValue: d ? `` : _(a.cart, i),
				removed: d,
				cart: a.cart,
				root: o.root,
			})
		: {
				ok: !1,
				reason: `invalid_coupon`,
				message: T(o.root),
				cart: a.cart,
				root: o.root,
			};
}
async function s({
	currentRoot: e,
	rootSelector: t,
	sectionId: n,
	prepareRoot: r,
}) {
	if (!n)
		return {
			ok: !1,
			reason: `missing_section_id`,
			message: `Cart section id missing`,
			root: e,
		};
	try {
		let i = new URL(window.location.href);
		i.searchParams.set(`section_id`, n);
		let a = await fetch(i.toString(), {
			credentials: `same-origin`,
			headers: { Accept: `text/html` },
		});
		if (!a.ok)
			return {
				ok: !1,
				reason: `missing_section_response`,
				message: `Unable to refresh cart`,
				root: e,
			};
		let o = await a.text();
		if (!o)
			return {
				ok: !1,
				reason: `missing_section_response`,
				message: `Cart section missing`,
				root: e,
			};
		let s = new DOMParser().parseFromString(o, `text/html`).querySelector(t);
		return s
			? (r?.(s), e.replaceWith(s), { ok: !0, root: s })
			: {
					ok: !1,
					reason: `missing_refreshed_root`,
					message: `Cart markup missing`,
					root: e,
				};
	} catch (t) {
		return {
			ok: !1,
			reason: `network`,
			message: t?.message || `Unable to refresh cart`,
			root: e,
		};
	}
}
function c(e) {
	typeof e != `number` ||
		!Number.isFinite(e) ||
		(document.querySelectorAll(`[data-cart-count]`).forEach((t) => {
			(t.textContent = String(e)), t.classList.toggle(`is-empty`, e === 0);
		}),
		document.querySelectorAll(`[data-cart-link]`).forEach((t) => {
			t.setAttribute(`aria-label`, `Winkelwagen, ${e} items`);
		}));
}
function l(e, t) {
	document.dispatchEvent(
		new CustomEvent(`cart:updated`, { detail: { cart: e, source: t } }),
	);
}
function u() {
	let e = window.Shopify?.routes?.root || `/`;
	return e.endsWith(`/`) ? e : `${e}/`;
}
async function d(n, r = e) {
	let i = String(n || ``).trim();
	if (!i) return { ok: !1, reason: `invalid_checkout_code`, message: r };
	try {
		let e = await S(),
			n = (await C(t, { input: y(e, { discountCode: i }) }))?.cartCreate?.cart,
			a = (n?.discountCodes || []).some(
				(e) => !!e.applicable && g(e.code) === g(i),
			),
			o = String(n?.checkoutUrl || ``).trim();
		if (a && o)
			return { ok: !0, code: i, checkoutUrl: o, kind: `discount_code` };
		let s = (await C(t, { input: y(e, { giftCardCode: i }) }))?.cartCreate
				?.cart,
			c = s?.appliedGiftCards || [],
			l = v(i).slice(-4),
			u = c.some((e) => v(e.lastCharacters) === l),
			d = String(s?.checkoutUrl || ``).trim();
		return !u || !d
			? { ok: !1, reason: `invalid_checkout_code`, message: r }
			: { ok: !0, code: i, checkoutUrl: d, kind: `gift_card` };
	} catch (e) {
		return {
			ok: !1,
			reason: `network`,
			message:
				e?.message ||
				`Code kon niet worden gecontroleerd. Probeer het opnieuw.`,
		};
	}
}
function f(e, t = ``) {
	return (n = String(e || ``).trim()), (r = n ? String(t || ``).trim() : ``), n;
}
function p() {
	return n;
}
function m() {
	return r;
}
function h() {
	(n = ``), (r = ``);
}
function g(e) {
	return String(e || ``)
		.trim()
		.toLowerCase();
}
function _(e, t) {
	let n = g(t),
		r = [
			...(e?.discount_applications || []),
			...(e?.cart_level_discount_applications || []),
		].find((e) => e.type === `discount_code` && g(e.title) === n),
		i = Number(r?.value);
	if (!Number.isFinite(i)) return ``;
	if (r?.value_type === `percentage`) return `${Math.round(i * 100) / 100}%`;
	if (r?.value_type !== `fixed_amount`) return ``;
	let a = Math.round(i * 100);
	return window.Shopify?.formatMoney
		? window.Shopify.formatMoney(a, window.DifraxMoneyFormat)
		: new Intl.NumberFormat(document.documentElement?.lang || `nl-NL`, {
				style: `currency`,
				currency: e?.currency || window.Shopify?.currency?.active || `EUR`,
			}).format(i);
}
function v(e) {
	return String(e || ``)
		.toLowerCase()
		.replace(/[^a-z0-9]/g, ``);
}
function y(e, { discountCode: t, giftCardCode: n }) {
	let r = (e.items || []).flatMap((e) => {
		let t = x(`ProductVariant`, e.id),
			n = Number(e.quantity);
		if (!t || !Number.isFinite(n) || n < 1) return [];
		let r = { merchandiseId: t, quantity: n },
			i = b(e.properties);
		i.length && (r.attributes = i);
		let a = x(
			`SellingPlan`,
			e.selling_plan_allocation?.selling_plan?.id || e.selling_plan,
		);
		return a && (r.sellingPlanId = a), [r];
	});
	if (!r.length) throw Error(`Gift card checkout cart is empty`);
	let i = { lines: r };
	n && (i.giftCardCodes = [n]);
	let a = b(e.attributes);
	a.length && (i.attributes = a);
	let o = [
		...(e.discount_applications || []),
		...(e.cart_level_discount_applications || []),
	]
		.filter((e) => e.type === `discount_code`)
		.map((e) => String(e.title || ``).trim())
		.filter(Boolean);
	return (
		t && o.push(t),
		o.length && (i.discountCodes = [...new Set(o)]),
		e.note && (i.note = String(e.note)),
		i
	);
}
function b(e) {
	return !e || typeof e != `object` || Array.isArray(e)
		? []
		: Object.entries(e)
				.filter(([e, t]) => e && t != null && String(t) !== ``)
				.map(([e, t]) => ({ key: e, value: String(t) }));
}
function x(e, t) {
	let n = String(t || ``).trim();
	return n
		? n.startsWith(`gid://shopify/`)
			? n
			: /^\d+$/.test(n)
				? `gid://shopify/${e}/${n}`
				: ``
		: ``;
}
async function S() {
	let e = await fetch(`${u()}cart.js`, {
		credentials: `same-origin`,
		headers: { Accept: `application/json` },
	});
	if (!e.ok) throw Error(`Gift card cart request failed`);
	return e.json();
}
async function C(e, t = {}) {
	let n = new URL(`/api/2026-01/graphql.json`, window.location.href),
		r = await fetch(n.toString(), {
			method: `POST`,
			credentials: `omit`,
			headers: {
				Accept: `application/json`,
				"Content-Type": `application/json`,
			},
			body: JSON.stringify({ query: e, variables: t }),
		});
	if (!r.ok) throw Error(`Gift card validation request failed`);
	let i = await r.json();
	if (i?.errors?.length) throw Error(`Gift card validation response failed`);
	return i?.data;
}
function w(e, t) {
	let n = g(t);
	return (e?.discount_codes || []).some(
		(e) => e.applicable === !0 && g(e.code) === n,
	)
		? !0
		: [
				...(e?.discount_applications || []),
				...(e?.cart_level_discount_applications || []),
			].some((e) => {
				let t = g(e.title);
				return e.type === `discount_code` && t === n;
			});
}
function T(t) {
	return (t instanceof HTMLElement && t.dataset.couponErrorMessage) || e;
}
async function E(e, { fallbackMessage: t, signal: n, ...r }) {
	try {
		let i = await fetch(e, {
				method: `POST`,
				credentials: `same-origin`,
				headers: {
					"Content-Type": `application/json`,
					Accept: `application/json`,
				},
				body: JSON.stringify(r),
				signal: n,
			}),
			a = await i.json();
		return i.ok
			? { ok: !0, cart: a }
			: { ok: !1, reason: `network`, message: O(a, t), cart: a };
	} catch (e) {
		if (e?.name === `AbortError`) throw e;
		return { ok: !1, reason: `network`, message: e?.message || t, cart: null };
	}
}
function D(e, t, n) {
	let r = e.querySelector(t);
	return r instanceof HTMLElement
		? g(r.dataset.appliedCoupon || ``) === String(n)
		: !1;
}
function O(e, t) {
	return e?.description || e?.message || t;
}
export {
	p as a,
	a as c,
	c as d,
	o as f,
	T as i,
	u as l,
	h as n,
	m as o,
	d as p,
	l as r,
	s,
	i as t,
	f as u,
};
